import React from 'react';
import LazyLoad from 'react-lazyload';
import { TableRow, TableCell, Avatar, IconButton } from '@material-ui/core';
import {
  FolderOutlined as FolderIcon,
  MoreVert as MoreVertIcon,
  CreateNewFolder as CreateNewFolderIcon,
  Delete as RemoveIcon,
  CloudUpload as CloudUploadIcon,
  Close as CloseIcon,
  CheckCircleOutline as CheckIcon
} from '@material-ui/icons';

const FolderRow = ({
  classes,
  selectedFiles,
  handleAnchorEl,
  handlePathChange,
  folder,
  rowCount
}) => {
  return (
    <LazyLoad
      overflow
      height={73}
      // throttle={100}
      offset={73}
      placeholder={<TableRow style={{ height: 73 }} />}
    >
      <TableRow
        className={classes.tableRow}
        onClick={handlePathChange(folder.fullPath)}
        hover
        tabIndex={-1}
      >
        <TableCell>{rowCount}</TableCell>
        <TableCell>
          <Avatar className={classes.avatar}>
            <FolderIcon />
          </Avatar>
        </TableCell>
        <TableCell>{folder.name}</TableCell>
        {selectedFiles && <TableCell />}
        <TableCell>Folder</TableCell>
        <TableCell align="right">
          <IconButton
            aria-label="more"
            aria-controls="long-menu"
            aria-haspopup="true"
            onClick={handleAnchorEl({
              type: 'folder',
              path: folder.fullPath
            })}
          >
            <MoreVertIcon />
          </IconButton>
        </TableCell>
      </TableRow>
    </LazyLoad>
  );
};

export default FolderRow;
